diy.angular.registerDirective('diyfmtoolbarsearch', ['diyl10n', 'diyfmsectionsdata', 'diyfmtracking',
function(diyl10n, diyfmsectionsdata, diyfmtracking) {
    
    var tpl = '\
        <div class="fm-toolbar-search" \
            diysearchbox="searchConfig" ng-model="searchQuery"></div>\
    ';

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            
            scope.searchConfig = {};
            
            scope.$watch(function() {
                return diyfmsectionsdata.getCurrentSubsection().getTitle();
            }, function(newTitle) {
                scope.searchConfig.placeholder = diyl10n('filemanager.search.placeholder').format(newTitle);
            });
            
            // Current search can change from subsection, like when 
            // subsection changed or when user clicked on breadcrumb
            // so we should keep local searchQuery in sync with it
            scope.$watch(function() {
                return diyfmsectionsdata.getCurrentSubsection().getSearch();
            }, function(newSearch) {
                scope.searchQuery = newSearch;
            });
            
            // When local searchQuery really changed
            // trigger subsection search (serSearch will actually perform search)
            scope.$watch('searchQuery', function(newSearch, oldSearch) {
                if (newSearch !== oldSearch) {
                    var subsection = diyfmsectionsdata.getCurrentSubsection();
                    if (subsection.getSearch() !== newSearch) {
                        diyfmtracking.track('newSearch', {search: newSearch});
                        subsection.setSearch(newSearch);
                    }
                }
            });
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmtoolbarsearch.js
 ** module id = 967
 ** module chunks = 0
 **/